// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"687":"2b83afd2","694":"f15456ee","787":"a89d9bad"}[chunkId] + ".chunk.js";
};